import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const FabricConsumptionMaster = () => {
  const [loading, setLoading] = useState(false);
  const [genderList, setGenderList] = useState([]);
  const [filters, setFilters] = useState({ item_id: "", });
  const [items, setItems] = useState([]);
  const [consumptionList, setConsumptionList] = useState([]);

  const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const fetchItems = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/itemsList`,
     {
    },{

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setItems(res.data.data.itemsList || []);
  } catch (error) {
    console.error("Fetch Items Error:", error);

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    }
  } finally {
    setLoading(false); // ✅ STOP LOADING
  }
};

const fetchFabricConsumptionList = async (pageNo = 1, itemId = filters.item_id, perPageValue = perPage) => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(`${BASE_URL}/fabricConsumptionList`,
      {
        item_id: itemId,
        page: pageNo,
        per_page: perPageValue
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setConsumptionList(res.data.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil((res.data.total_records || 0) / (res.data.per_page || perPageValue))
    );
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};


 const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };





  useEffect(() => {
    fetchItems();
  }, []);

          useEffect(() => { fetchFabricConsumptionList(1); }, [perPage]);

          const theadStyle={
                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",
                }

  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* 🔷 Header */}
       <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Fabric Consumption Master
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
            <Row className="align-items-center">
          <Col md={4}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Select Items</Form.Label>
    <Form.Select
      value={filters.item_id}
      onChange={(e) =>
        setFilters({ ...filters, item_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">All Items</option>
      {items.map((g) => (
        <option key={g.id} value={g.id}>
          {g.item_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

<Col md={3}>
                           <Form.Group className="mb-3">
                                           <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                               <Form.Select
                                style={{
                                               borderRadius: "10px",
                                               border: "2px solid #1565C1",
                                             }}
                                 value={perPage}
                                 onChange={(e) => {
                                   const value = Number(e.target.value);
                                   setPerPage(value);
                                   setPage(1);

                                 }}

                               >
                                 <option value={10}>10 Per Page</option>
                                       <option value={25}>25 Per Page</option>
                                       <option value={50}>50 Per Page</option>
                                       <option value={100}>100 Per Page</option>
                               </Form.Select>
                               </Form.Group>
                           </Col>


          <Col md={4} className="d-flex gap-3 mt-3">
                  {/* SEARCH */}
                  <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#1565C1",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                    onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                    onClick={() => {
                       fetchFabricConsumptionList();
                    }}
                  >
                    <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                  </Button>

                  {/* RESET */}
                  <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    // 1️⃣ Reset state
    setFilters({ item_id: "" });
    setPage(1);
    setPerPage(10);

    // 2️⃣ Call API with reset values
    fetchFabricConsumptionList(1, "", 10); // page=1, search="", perPage=10
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

                </Col>
        </Row>
        </Card.Body>
      </Card>



        {loading && (
        <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
            <div className="loading-progress"></div>
            </div>

            <p className="loading-text">Loading, please wait...</p>
        </div>
        )}
      {/* 📄 TABLE */}
      {!loading && (
  <>
    {/* TABLE CARD */}
    <Card
      className="mb-4 border-0"
      style={{
        background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
        boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
        overflow: "hidden",
      }}
    >
      <Table bordered hover responsive striped>
        <thead>
          <tr>
            <th style={theadStyle}>SL No.</th>
            <th style={theadStyle}>Item Name</th>
            <th style={theadStyle}>Fabric Name</th>
            <th style={theadStyle}>Size</th>
            <th style={theadStyle}>Consumption</th>
          </tr>
        </thead>

        <tbody>
          {consumptionList.length > 0 ? (
            consumptionList.map((row, index) => (
              <tr key={row.id}>
                {/* <td className="text-center">{index + 1}</td> */}

                <td className="text-center">
                  {(page - 1) * perPage + index + 1}
                </td>
                <td className="text-center">{row.item_name}</td>
                <td className="text-center">{row.fabric_name}</td>
                <td className="text-center">{row.size}</td>
                <td className="text-center">{row.consumption} mtr.</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-muted py-4">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Card>

    {/* PAGINATION */}
    {totalPages > 1 && (
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination shadow-sm">
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricConsumptionList(1)}>«</button>
            </li>

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricConsumptionList(page - 1)}>‹</button>
            </li>

            {getPageNumbers().map((p) => (
              <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchFabricConsumptionList(p)}>
                  {p}
                </button>
              </li>
            ))}

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricConsumptionList(page + 1)}>›</button>
            </li>

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricConsumptionList(totalPages)}>»</button>
            </li>
          </ul>
        </nav>
      </div>
    )}
  </>
)}



    </div>
  );
};

export default FabricConsumptionMaster;
